import React from "react";
import "./Modalqr.css";

const Modalqr = ({ show, handleClose, children }) => {
  return (
    <div
      className={`modalqr-overlay ${show ? "show" : "hide"}`}
      style={{ display: show ? "flex" : "none" }}
      onClick={handleClose}
    >
      <div className="modalqr-content" onClick={(e) => e.stopPropagation()}>
        <span className="closeqr" onClick={handleClose}>
          &times;
        </span>
        {children}
      </div>
    </div>
  );
};

export default Modalqr;
